import script from "./BillTotals.vue?vue&type=script&setup=true&lang=js"
export * from "./BillTotals.vue?vue&type=script&setup=true&lang=js"

import "./BillTotals.vue?vue&type=style&index=0&id=0dc8e09e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dc8e09e"]])

export default __exports__